import {ReportDropdown} from '../../../report-dropdown';
import {ShowFilter} from '../show-filter';
import {ShowResultsFilter} from '../../../show-results-filter';
import {MarkingPeriodFilter} from '../../../marking-period-filter';
import {useBehaviorSubject, useStream} from '@esgi/ui-kit/utils';
import {RubricResultReportService} from '../../../../../../service';
import {MarkingPeriod} from '../../../../../../service/types';
import {ReportFilterBodyStyled, ReportFilterContainerStyled, ReportHeaderRowStyled} from './index.styled';
import {Filter} from '../../../../../../service/settings-service';

type HeaderProps = {
	service: RubricResultReportService;
};

export function Header({service}: HeaderProps) {
	const students = useStream(service.studentLevelService.students$);
	const selectedStudent = useStream(service.studentLevelService.selectedStudent$);
	const showNotes = useBehaviorSubject<boolean>(service.studentLevelService.showNotes$);
	const showSummary = useBehaviorSubject<boolean>(service.studentLevelService.showSummary$);
	const showInColor = useBehaviorSubject<boolean>(service.studentLevelService.showInColor$);
	const filter = useStream<Filter | null>(service.settingsService.filter$);

	return (
		<ReportFilterBodyStyled>
			<ReportHeaderRowStyled>
				<ReportFilterContainerStyled>
					{selectedStudent && (
						<ReportDropdown
							title='Student'
							onSelected={({id}) => service.selectStudent(id)}
							entities={students}
							selectedValue={selectedStudent}
							data-cy='student-level-report-header-'
						/>
					)}
				</ReportFilterContainerStyled>
				<ShowFilter
					showNotes={showNotes}
					showSummary={showSummary}
					showInColor={showInColor}
					onShowInColorChange={(value) => service.studentLevelService.setShowInColorFilter(value)}
					onShowNotesChange={(value) => service.studentLevelService.setShowNotesFilter(value)}
					onShowSummaryChange={(value) => service.studentLevelService.setShowSummaryFilter(value)}
				/>
				<ShowResultsFilter
					onCarryForwardClicked={(value) => service.settingsService.setCarryForward(value)}
					onShowBaseLineClicked={(value) => service.settingsService.setShowBaseLine(value)}
					carryScoresForward={filter?.carryScoresForward ?? false}
					showBaseline={filter?.showBaseline ?? false}
				/>
				<MarkingPeriodFilter
					onChanged={(value) => service.settingsService.setMarkingPeriod(value ? MarkingPeriod.Current : MarkingPeriod.All)}
					showCurrentMarkingPeriod={(filter?.showCurrentMarkingPeriod === MarkingPeriod.Current) ?? false}
				/>
			</ReportHeaderRowStyled>
		</ReportFilterBodyStyled>
	);
}
